import { V1_ANNOUNCEMENTS_PATH } from '@/constant/routers/path';
import request from '@/services/http.service';
import type {
  AnnouncementData,
  AnnouncementDataFromAPI,
  AnnouncementDetailResponse,
  AnnouncementListResponse,
} from '@/types/announcement';

/** 一覧 API の data をバナー表示用に結合する（BaseLayout / ゲストトップで共通） */
const mapAnnouncementItem = (a: AnnouncementDataFromAPI): AnnouncementData => ({
  id: a.id,
  title: a.title,
  startDate: a.start_date,
});

export const mapAnnouncementListResponseData = (
  data: AnnouncementListResponse['data']
): AnnouncementData[] => [
  ...(data.maintenance_announcements || []).map(mapAnnouncementItem),
  ...(data.general_announcements || []).map(mapAnnouncementItem),
];

export const getAnnouncements = (): Promise<AnnouncementListResponse> => {
  return request(V1_ANNOUNCEMENTS_PATH, {
    method: 'GET',
  });
};

export const getAnnouncementDetail = (id: number | string): Promise<AnnouncementDetailResponse> => {
  return request(`${V1_ANNOUNCEMENTS_PATH}/${id}`, {
    method: 'GET',
  });
};
